// pages/Seguranca.jsx
import React from 'react';

export default function Seguranca() {
  return (
    <div className="max-w-4xl mx-auto p-6 text-gray-800">
      <h1 className="text-2xl font-bold mb-4">Segurança</h1>
      <p className="mb-4">Quanto aos seus dados pessoais de endereço, pagamento e detalhes do pedido, garantimos que serão exclusivamente utilizados para o processamento das solicitações e não serão divulgados para qualquer outra finalidade.</p>
      <p>Asseguramos a segurança no tráfego de dados durante as transações, seja por cartão de crédito ou outros meios, por meio da tecnologia SSL (Secure Socket Layer). Isso implica que somente nossa empresa terá acesso a essas informações, proporcionando a máxima confidencialidade.</p>
    </div>
  );
}